import '../../ComplaintsComponent/Retail/CustomerDetails.css';

// RTL tickets carry a `retailer` (not `customer`) with a split first/last name.
// Reuses the shared customer-details-theme styling for visual parity.
export default function CustomerDetails(props) {
  const item = props.item || {};
  const retailer = item.retailer || {};
  const fullName = `${retailer.first_name || ''} ${retailer.last_name || ''}`.trim();

  return (
    <div className="heads customer-details-theme">
      <div className="customer-details-container">
        <div className="first">
          <div className="firstbox">
            <span>Name</span>
            <p>{fullName || 'N/A'}</p>
          </div>
          <div className="secondbox">
            <span>Address 1</span>
            <p>{retailer.address || 'N/A'}</p>
          </div>
          <div className="thirdbox">
            <span>City</span>
            <p>{retailer.city || 'N/A'}</p>
          </div>
        </div>

        <div className="second">
          <div className="firstbox">
            <span>Email</span>
            <p>{retailer.email || 'N/A'}</p>
          </div>
          <div className="secondbox">
            <span>Address 2</span>
            <p>{retailer.address_2 || 'N/A'}</p>
          </div>
          <div className="thirdbox">
            <span>Pincode</span>
            <p>{retailer.pincode || 'N/A'}</p>
          </div>
        </div>

        <div className="third">
          <div className="firstbox">
            <span>Mobile Number</span>
            <p>{retailer.mobile || 'N/A'}</p>
          </div>
          <div className="secondbox">
            <span>State</span>
            <p>{retailer.state_name || 'N/A'}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
